import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Popper,
  PopperProps,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'

import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import { ElementType, MutableRefObject, RefAttributes, useEffect, useRef, useState } from 'react'

import { HighlightOff } from '@material-ui/icons'
import { Control, ListProps } from '../../../core'
import { ReplaceText } from '../../replace-text/replace-text'
import { SendBack } from '../sendback-model'

function insertLabel(s: string) {
  return s.substring(s.indexOf('{') + 1, s.indexOf('}'))
}
export function withTooltip(tooltip: string, element: any, placement = 'right-end'): JSX.Element {
  return tooltip ? (
    <Tooltip
      title={<span style={{ whiteSpace: 'pre-line', fontSize: 12 }}>{tooltip}</span>}
      placement={placement as any}
    >
      <span>{element}</span>
    </Tooltip>
  ) : (
    element
  )
}

function SendbackReturnText({ sendback, onInsert }: { sendback: SendBack; onInsert: (v: string) => void }) {
  let matchMapRef = useRef<Record<string, string | null>>({})
  let currentMatchRef = useRef<string | null>(null)

  const { approvedText, description } = sendback
  const [text, setText] = useState(approvedText![0])
  const onApprovedTextChange = (e: any) => {
    const v = e.target.value

    sendback.insertedReturnText = undefined

    setText(v)
    setInsert(v)

    if (v && !v.includes('${')) {
      sendback.returnText = v
      sendback.selected = true
    }
  }

  const matchMap = matchMapRef.current

  const [open, setOpen] = useState(false)
  const onPrompt = (match: string, i: number) => () => {
    const id = match + '!!' + i
    currentMatchRef.current = id
    setInsert(matchMap[id] || '')
    setOpen(true)
  }

  const list = ReplaceText({
    input: text,
    decorator: (match, i) => {
      const link = matchMap[match + '!!' + i] || insertLabel(match)
      return (
        <a
          key={i}
          onClick={onPrompt(match, i)}
          style={{ color: '#7fb3f7', textDecoration: 'underline', cursor: 'pointer' }}
        >
          {link}
        </a>
      )
    },
    pattern: /\$\{([^{}]*)\}/gm,
  })

  const [insert, setInsert] = useState('')
  const onSubmit = () => {
    sendback.selected = true
    onInsert(insert)
    if (currentMatchRef?.current) {
      matchMap[currentMatchRef.current] = insert

      const match = currentMatchRef.current.substring(0, currentMatchRef.current.indexOf('!!'))

      if (!sendback?.insertedReturnText?.length) {
        sendback.insertedReturnText = text.replace(match, insert)
      } else {
        sendback.insertedReturnText = sendback.insertedReturnText.replace(match, insert)
      }
      console.info('matchMap', matchMap, sendback.insertedReturnText)
    } else {
      sendback.insertedReturnText = text
    }
    setOpen(false)
  }

  return (
    <>
      <Grid item container direction="row">
        <Grid
          item
          container
          spacing={2}
          alignContent={'center'}
          alignItems={'center'}
          direction={'row'}
          style={{ flexWrap: 'nowrap' }}
        >
          <Grid item>
            <Typography variant="caption" style={{ fontSize: 12 }}>
              Approved Return Text
            </Typography>
          </Grid>

          <Grid item style={{ visibility: approvedText!?.length > 1 ? undefined : 'hidden' }}>
            <Select multiple={false} value={text || ''} label="Text" onChange={onApprovedTextChange}>
              {approvedText?.map((a, i) => (
                <MenuItem key={i} value={a}>
                  {i + 1}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>

        <Grid item>{list}</Grid>
      </Grid>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>{description}</DialogTitle>
        <DialogContent>
          <DialogContentText>Insert Text</DialogContentText>
          <TextField
            margin="dense"
            value={insert || ''}
            onChange={(e) => setInsert(e.target.value)}
            style={{ fontSize: 12 }}
            multiline
            rows={4}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={onSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

function SendbackComment({ sendback }: { sendback: SendBack }) {
  const [text, setText] = useState(sendback.comment)
  const onChange = (e: any) => {
    const v = e.target.value
    sendback.comment = v
    setText(v)
  }

  return (
    <Grid item container direction="row">
      <TextField
        margin="dense"
        placeholder="Comments"
        value={text || ''}
        onChange={onChange}
        style={{ fontSize: 12, color: '#fff' }}
        InputLabelProps={{ style: { fontSize: 12, color: '#fff' } }}
        multiline
        rows={2}
        fullWidth
      />
    </Grid>
  )
}

function SendbackSelection({ sendback }: { sendback: SendBack }) {
  const { approvedText, description, subCategory, useComments } = sendback
  const [selected, setSelected] = useState(sendback.selected)

  const onChange = (e: any) => {
    const v = e.target.checked
    sendback.selected = v
    setSelected(v)
  }

  const onKeyUp = (e: any) => {
    const v = e.target.value
    if (e.key === 'Enter') {
      sendback.selected = sendback.selected
      setSelected(!selected)
    }
  }

  return (
    <>
      <FormControlLabel
        control={<Checkbox onKeyUp={onKeyUp} checked={selected || false} onChange={onChange} />}
        label={withTooltip(
          description,
          <Box component="div" fontSize={12}>
            {subCategory}
          </Box>,
        )}
      />
      {approvedText?.length ? <SendbackReturnText sendback={sendback} onInsert={() => setSelected(true)} /> : null}

      {useComments ? <SendbackComment sendback={sendback} /> : null}
    </>
  )
}

export function SendBackCard({ sendback }: { sendback: SendBack }) {
  const { description, subCategory } = sendback
  const list = sendback.subReasons || []

  return (
    <Grid
      item
      container
      direction="column"
      spacing={0}
      style={{ color: '#fff', flexWrap: 'nowrap', fontSize: 12, padding: 12, width: 640 }}
    >
      <Grid item>{withTooltip(description, <Typography variant="overline"> {subCategory} </Typography>)}</Grid>

      {list.map((v, i) => (
        <SendbackSelection key={i} sendback={v} />
      ))}

      <Grid item container direction="row">
        <Grid item style={{ flexGrow: 1 }} />
        <Grid item></Grid>
      </Grid>
    </Grid>
  )
}

const SearchPopper =
  (ctr: Control, onParentBlur: (e: any) => void, width: number, close: () => void) =>
  (
    props: JSX.IntrinsicAttributes &
      Omit<PopperProps, 'direction'> & {
        component?: ElementType<any> | undefined
        components?: { Root?: ElementType<any> | undefined } | undefined
        componentsProps?: { root?: any | undefined } | undefined
        sx?: any | undefined
      } & RefAttributes<HTMLDivElement>,
  ) => {
    const { children, ...rest } = props
    const list = getSubReasons(ctr)

    const sideWidth = width * 0.71

    const onBlur = (e: any) => {
      onParentBlur(e)
    }
    const onMouseOver = (e: any) => {
      e.target.focus()
    }
    return (
      <Popper
        onBlur={onBlur}
        {...rest}
        style={{ width, minWidth: width, paddingBottom: 12 }}
        popperOptions={{}}
        placement="bottom-start"
      >
        <Grid
          container
          direction={'row'}
          style={{ width, minWidth: width, flexWrap: 'nowrap', backgroundColor: '#333' }}
          onBlur={onBlur}
        >
          <Grid item style={{ width: 160, minWidth: 160 }}>
            {children as any}
          </Grid>
          <Grid
            item
            container
            onMouseOver={onMouseOver}
            direction={'row'}
            style={{ overflowY: 'auto', minWidth: sideWidth, width: sideWidth, maxHeight: '65vh' }}
          >
            {list.map((v, i) => (
              <SendBackCard key={i} sendback={v} />
            ))}
          </Grid>

          <div style={{ position: 'relative', top: 2, right: -1 }}>
            <IconButton onClick={close} style={{ width: '8px', height: '8px' }}>
              <HighlightOff />
            </IconButton>
          </div>
        </Grid>
      </Popper>
    )
  }

export function getAutoCompleteInput(
  inputRef?: MutableRefObject<HTMLElement | HTMLInputElement>,
): () => HTMLInputElement | null {
  let inputEl: HTMLInputElement
  return () => {
    if (inputEl) {
      return inputEl
    }
    const el: HTMLInputElement = inputRef?.current as any
    if (el && el.children) {
      inputEl = el.children[1].children[0] as any
      return inputEl
    }
    return null
  }
}

export function inputValueSelection(fn: () => HTMLInputElement | null): (value?: string) => void {
  return (value) => {
    const el = fn()
    if (el) {
      el.value = value || el.value || ''
      el.focus()
      el.setSelectionRange(el.value.length, el.value.length)
    }
  }
}

let searchOpen = false

function getSubReasons(ctr: Control) {
  let s: SendBack

  const values = ctr.value && ctr.value.getState().value
  if (Array.isArray(values)) {
    s = values[values.length - 1]
  }
  if (s?.subReasons) {
    return [s]
  }
  return []
}

function getClasses(related: any) {
  const bs = related.classList ? [...related.classList] : null
  const classes: string[] = Array.isArray(bs) ? (bs as string[]) : []
  return classes
}

let lastSelected: SendBack = null
export function Search(c: Control) {
  const props: ListProps = c.field as ListProps
  const {
    tooltip,
    inputRef,
    required,
    placeholder,
    label,
    name,
    disableClearable,
    listLabel,
    listValue,
    textLabel,
    onEnter,
    onEnterValid,
  } = props
  const [value, setValue, error] = c.value((s) => [s.value, s.setValue, s.error])
  const disabled = c.disabled((s) => s.value)

  const onChange = (_: any, v: any) => {
    searchOpen = false
    if (listValue) {
      setValue(listValue(v))
    } else {
      lastSelected = v[v.length - 1]
      setValue(v)
    }
  }

  if (!c.list) {
    throw new Error('list required for search component: ' + label)
  }

  const list = c.list((s) => s.value)

  const getOptionLabel = (item: any, isList = false) => {
    if (!item) {
      searchOpen = false
      return ''
    }
    searchOpen = isList
    // @ts-ignore
    let label = isList ? listLabel(item) : textLabel ? textLabel(item) : listLabel(item) || ''
    if (lastSelected && lastSelected === item) {
      label += ' *'
    }
    return label
  }

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    ignoreAccents: true,
    stringify: (item: any) => {
      return getOptionLabel(item, true)
    },
  })

  const onInputChange = props.onInputChange
    ? (e: any) => {
        const v = e.target.value
        // @ts-ignore
        props.onInputChange(v, e)
      }
    : undefined

  const onClose = (e: any) => {
    setOpen(true)
    const v = c.value.getState()

    if (e.currentTarget?.id === 'search_reason') {
      const related = e.relatedTarget

      if (e.type === 'mousedown' && !related) {
        setOpen(false)
        return
      }

      if (related) {
        /*
        // TODO: better class query
        const bs = related.classList ? [...related.classList] : null;
        const classes: string[] = Array.isArray(bs) ? (bs as string[]) : [];
        const lastClass = classes[classes.length - 1];

        if (lastClass && lastClass.includes('MuiButtonBase')) {
          setOpen(false);
        }
        setOpen(true);
        */
      }

      if (related?.nodeName === 'INPUT') {
        setOpen(true)
      }
    }
  }

  const [open, setOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)

  // Guards against the dropdown getting stuck open (and its portaled Popper
  // rendering at 0,0) when the tab it lives in is hidden (e.g. switching to
  // Review Questions) without a matching blur/close case above.
  useEffect(() => {
    if (!open || typeof IntersectionObserver === 'undefined') {
      return
    }
    const el = rootRef.current
    if (!el) {
      return
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          setOpen(false)
        }
      },
      { threshold: 0 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [open])

  const openPopper = () => {
    setOpen(true)
  }

  const id = c.id || c.field.id

  const onBlur = (e: any) => {
    if (e.currentTarget?.id === 'search_reason') {
      console.info('info', e)
    }

    const related = e.relatedTarget
    if (related) {
      if (related.id === 'add-element') {
        setOpen(false)
      }
      const classes = getClasses(e)
      if (related.id === '') {
        const relatedParent = related.parentElement
        if (relatedParent) {
          const parentClasses = getClasses(relatedParent)
          const parentClass = parentClasses[0]
          if (parentClass === 'MuiPaper-root') {
            setOpen(false)
          }
          console.info('parentClass', parentClass)
        }
      } else {
        const lastClass = classes[classes.length - 1]
        console.info('lastClass', lastClass)
      }
    } else {
      if (related?.id === '') {
        setOpen(false)
      }
    }
  }

  return (
    <div ref={rootRef}>
      {withTooltip(
        tooltip!,
        <Autocomplete
          size="small"
          open={open}
          freeSolo={true}
          autoSelect={false}
          multiple
          clearOnBlur
          disableCloseOnSelect
          filterOptions={filterOptions}
          disableClearable={disableClearable}
          options={list}
          openOnFocus={true}
          getOptionLabel={getOptionLabel}
          filterSelectedOptions={false}
          onBlur={onBlur}
          onChange={onChange}
          onOpen={openPopper}
          onClose={onClose}
          disabled={disabled}
          style={{ ...{ width: '100%' } }}
          value={Array.isArray(value) ? value : []}
          id={id ? id : 'search_' + (label ? label?.toLowerCase()?.trim() : id)}
          ListboxProps={{
            style: {
              maxHeight: '74vh',
            },
          }}
          PopperComponent={SearchPopper(c, onBlur, 660, () => setOpen(false)) as any}
          renderInput={(params: any) => (
            <TextField
              {...params}
              ref={inputRef}
              label={label}
              name={name}
              variant="standard"
              onBlur={onBlur}
              sx={{ fontSize: 12, color: '#fff' }}
              style={{ width: '100%' }}
              onChange={onInputChange}
              placeholder={placeholder}
              required={required}
              error={!!error}
              InputLabelProps={{ style: { fontSize: 12, color: '#fff' } }}
              data-field={label}
            />
          )}
        />,
      )}
    </div>
  )
}

type SendbackAutoCompleteProps = {
  control: Control
}

export function SendbackAutoComplete({ control }: SendbackAutoCompleteProps) {
  return (
    <div>
      <Search {...control} />
    </div>
  )
}
